(function (global, factory) {
  if (typeof module === "object" && module.exports) {
    module.exports = function (window, document) {
      return factory(window, document, true);
    };
  } else {
    factory(global, global.document, false);
  }
})(typeof window !== "undefined" ? window : this, function (window, document, commonJS) {
  "use strict";

  if (!window || !document) return null;

  var GLOBAL_NAME = "NINTEProductGalleryCounterV1";
  var ROOT_SELECTOR = '[data-product-gallery-loader="v1"]';
  var COUNTER_SELECTOR = "[data-gallery-counter]";
  var MAIN_SELECTOR = ".slider-for";
  var NAV_SELECTOR = ".slider-nav";
  var NAV_SLIDE_SELECTOR = ".slick-slide:not(.slick-cloned)";
  var THUMBNAIL_SELECTOR = ".product-single__thumbnail";
  var CURRENT_SELECTOR = "[data-gallery-counter-current]";
  var TOTAL_SELECTOR = "[data-gallery-counter-total]";
  var A11Y_SELECTOR = "[data-gallery-counter-a11y]";
  var CURRENT_SLIDE_SELECTOR = ".slick-slide.slick-current:not(.slick-cloned)";
  var DOT_SELECTOR = ".slick-dots";
  var DOTS_ATTRIBUTE = "data-gallery-counter-dots-hidden";
  var MARKED_DOTS_SELECTOR = '[data-gallery-counter-dots-hidden="true"]';
  var MOBILE_QUERY = "(max-width: 1024px)";
  var EVENT_NAMESPACE = ".ninteGalleryCounter";
  var MAX_READY_ATTEMPTS = 20;
  var READY_DELAY_MS = 100;
  var states = [];
  var media = null;

  if (window[GLOBAL_NAME]) {
    window[GLOBAL_NAME].boot(document);
    return window[GLOBAL_NAME];
  }

  function forEach(nodes, callback) {
    Array.prototype.forEach.call(nodes || [], callback);
  }

  function integer(value) {
    if (typeof value === "string" && /^(0|[1-9][0-9]*)$/.test(value)) {
      value = parseInt(value, 10);
    }
    return typeof value === "number" && isFinite(value) &&
      Math.floor(value) === value ? value : null;
  }

  function one(scope, selector) {
    var nodes;
    if (!scope || typeof scope.querySelectorAll !== "function") return null;
    nodes = scope.querySelectorAll(selector);
    return nodes && nodes.length === 1 ? nodes[0] : null;
  }

  function rootsInScope(scope) {
    var roots = [];
    if (!scope) return roots;
    if (typeof scope.matches === "function" && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }
    if (typeof scope.querySelectorAll === "function") {
      forEach(scope.querySelectorAll(ROOT_SELECTOR), function (root) {
        if (roots.indexOf(root) === -1) roots.push(root);
      });
    }
    return roots;
  }

  function findState(root) {
    var match = null;
    forEach(states, function (state) {
      if (state.root === root) match = state;
    });
    return match;
  }

  function clearReadyTimer(state) {
    if (state.readyTimer !== null && typeof window.clearTimeout === "function") {
      window.clearTimeout(state.readyTimer);
    }
    state.readyTimer = null;
  }

  function restoreDots(state) {
    if (!state || !state.root || typeof state.root.querySelectorAll !== "function") return;
    forEach(state.root.querySelectorAll(MARKED_DOTS_SELECTOR), function (dots) {
      if (dots && typeof dots.removeAttribute === "function") {
        dots.removeAttribute(DOTS_ATTRIBUTE);
      }
    });
  }

  function deactivate(state) {
    if (!state) return;
    restoreDots(state);
    if (state.counter) {
      state.counter.hidden = true;
      state.counter.removeAttribute("data-gallery-counter-active");
    }
  }

  function expectedTotal(state) {
    var value = integer(state.root.getAttribute("data-gallery-image-count"));
    return value !== null && value >= 2 && value <= 50 ? value : null;
  }

  function finalSlideTotal(slider, reportedTotal) {
    var reported = integer(reportedTotal);
    var slides;
    var count;
    if (reported !== null && reported >= 1 && reported <= 50) return reported;
    if (!slider || typeof slider.querySelectorAll !== "function") return null;
    slides = slider.querySelectorAll(".slick-slide:not(.slick-cloned)");
    count = slides ? integer(slides.length) : null;
    return count !== null && count >= 1 && count <= 50 ? count : null;
  }

  function isMobile() {
    return !!(media && media.matches === true);
  }

  function currentIndexFromDom(slider) {
    var current;
    if (!slider || typeof slider.querySelectorAll !== "function") return null;
    current = slider.querySelectorAll(CURRENT_SLIDE_SELECTOR);
    if (!current || current.length !== 1) return null;
    return integer(current[0].getAttribute("data-slick-index"));
  }

  function sliderDots(slider) {
    if (!slider || typeof slider.querySelectorAll !== "function") return [];
    return slider.querySelectorAll(DOT_SELECTOR);
  }

  function thumbnailSelection(state, index, expected) {
    var thumbnails = [];
    var allThumbnails;
    var selected = null;
    var selectedCount = 0;
    var slides;
    var invalid = false;

    if (!state || !state.nav || !state.nav.classList ||
        !state.nav.classList.contains("slick-initialized") ||
        typeof state.nav.querySelectorAll !== "function") return null;

    slides = state.nav.querySelectorAll(NAV_SLIDE_SELECTOR);
    allThumbnails = state.nav.querySelectorAll(THUMBNAIL_SELECTOR);
    forEach(slides, function (slide) {
      var slideThumbnails = slide.querySelectorAll(THUMBNAIL_SELECTOR);
      var thumbnail;
      if (!slideThumbnails || slideThumbnails.length > 1) {
        invalid = true;
        return;
      }
      if (slideThumbnails.length === 0) return;
      thumbnail = slideThumbnails[0];
      thumbnails.push(thumbnail);
      if (integer(slide.getAttribute("data-slick-index")) === index) {
        selectedCount += 1;
        selected = thumbnail;
      }
    });

    return !invalid && thumbnails.length === expected && selectedCount === 1 && selected ?
      { all: allThumbnails, selected: selected } : null;
  }

  function syncThumbnailSelection(selection) {
    if (!selection || !selection.selected) return false;
    forEach(selection.all, function (thumbnail) {
      if (thumbnail !== selection.selected) {
        if (thumbnail.classList && thumbnail.classList.contains("active-thumb")) {
          thumbnail.classList.remove("active-thumb");
        }
        if (thumbnail.getAttribute("aria-current") !== null) {
          thumbnail.removeAttribute("aria-current");
        }
      }
    });
    if (!selection.selected.classList.contains("active-thumb")) {
      selection.selected.classList.add("active-thumb");
    }
    if (selection.selected.getAttribute("aria-current") !== "true") {
      selection.selected.setAttribute("aria-current", "true");
    }
    return true;
  }

  function activate(state, index, reportedTotal) {
    var expected;
    var normalizedIndex = integer(index);
    var dots;
    var selection;

    try {
      expected = finalSlideTotal(state.slider, reportedTotal);
      if (expected === null) expected = expectedTotal(state);
      dots = sliderDots(state.slider);
      selection = thumbnailSelection(state, normalizedIndex, expected);
      if (!isMobile() || expected === null || expected < 2 || normalizedIndex === null ||
          normalizedIndex < 0 || normalizedIndex >= expected ||
          !dots || dots.length > 1 || !selection) {
        deactivate(state);
        return false;
      }

      syncThumbnailSelection(selection);
      state.current.textContent = String(normalizedIndex + 1);
      state.total.textContent = String(expected);
      state.a11y.textContent = "Image " + (normalizedIndex + 1) + " of " + expected;
      state.counter.hidden = false;
      state.counter.setAttribute("data-gallery-counter-active", "true");
      restoreDots(state);
      forEach(dots, function (item) {
        item.setAttribute(DOTS_ATTRIBUTE, "true");
      });
      return true;
    } catch (error) {
      deactivate(state);
      return false;
    }
  }

  function syncFromDom(state, reportedTotal) {
    return activate(state, currentIndexFromDom(state.slider), reportedTotal);
  }

  function observeSettledSlide(state) {
    if (!state || state.observer || !state.slider ||
        typeof window.MutationObserver !== "function") return;
    state.observer = new window.MutationObserver(function () {
      if (!state.destroyed && state.bound && state.slider) {
        syncFromDom(state, null);
      }
    });
    var options = {
      attributes: true,
      attributeFilter: ["class", "aria-hidden"],
      childList: true,
      subtree: true
    };
    state.observer.observe(state.slider, options);
    state.observer.observe(state.nav, options);
  }

  function observeRootReplacement(state) {
    if (!state || state.rootObserver || !state.root ||
        typeof window.MutationObserver !== "function") return;
    state.rootObserver = new window.MutationObserver(function () {
      var slider;
      var nav;
      if (state.destroyed) return;
      slider = one(state.root, MAIN_SELECTOR);
      nav = one(state.root, NAV_SELECTOR);
      if (slider === state.slider && nav === state.nav) return;
      clearReadyTimer(state);
      unbind(state);
      deactivate(state);
      state.readyAttempts = 0;
      tryBind(state);
    });
    state.rootObserver.observe(state.root, { childList: true, subtree: true });
  }

  function unbind(state) {
    if (!state) return;
    try {
      if (state.$slider && typeof state.$slider.off === "function") {
        state.$slider.off(EVENT_NAMESPACE);
      }
    } catch (error) {
      // The fallback below is the customer-visible recovery path.
    }
    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }
    state.bound = false;
    state.$slider = null;
    state.slider = null;
    state.nav = null;
  }

  function scheduleReady(state) {
    if (!state || state.destroyed || state.bound || state.readyTimer !== null ||
        state.readyAttempts >= MAX_READY_ATTEMPTS ||
        typeof window.setTimeout !== "function") return;
    state.readyAttempts += 1;
    state.readyTimer = window.setTimeout(function () {
      state.readyTimer = null;
      tryBind(state);
    }, READY_DELAY_MS);
  }

  function tryBind(state) {
    var slider;
    var nav;
    var jq;
    var $slider;
    if (!state || state.destroyed || state.bound) return;
    try {
      slider = one(state.root, MAIN_SELECTOR);
      nav = one(state.root, NAV_SELECTOR);
      jq = window.jQuery;
      if (!slider || !nav || typeof jq !== "function") {
        scheduleReady(state);
        return;
      }
      $slider = jq(slider);
      if (!$slider || $slider.length !== 1 || typeof $slider.on !== "function" ||
          typeof $slider.off !== "function") {
        scheduleReady(state);
        return;
      }

      state.slider = slider;
      state.nav = nav;
      state.$slider = $slider;
      state.onLifecycle = function (event, slick) {
        syncFromDom(state, slick ? slick.slideCount : null);
      };
      state.onAfterChange = function (event, slick, currentSlide) {
        activate(state, currentSlide, slick ? slick.slideCount : null);
      };
      state.onDestroy = function () {
        unbind(state);
        deactivate(state);
        state.readyAttempts = 0;
        scheduleReady(state);
      };

      $slider.on("init.ninteGalleryCounter reInit.ninteGalleryCounter", state.onLifecycle);
      $slider.on("afterChange.ninteGalleryCounter", state.onAfterChange);
      $slider.on("destroy.ninteGalleryCounter", state.onDestroy);
      state.bound = true;
      observeSettledSlide(state);
      clearReadyTimer(state);

      if (slider.classList && slider.classList.contains("slick-initialized")) {
        syncFromDom(state, null);
      } else {
        deactivate(state);
      }
    } catch (error) {
      unbind(state);
      deactivate(state);
      scheduleReady(state);
    }
  }

  function createState(root) {
    var counter = one(root, COUNTER_SELECTOR);
    if (!counter) return null;
    var state = {
      root: root,
      counter: counter,
      current: one(counter, CURRENT_SELECTOR),
      total: one(counter, TOTAL_SELECTOR),
      a11y: one(counter, A11Y_SELECTOR),
      slider: null,
      nav: null,
      $slider: null,
      bound: false,
      destroyed: false,
      readyAttempts: 0,
      readyTimer: null,
      observer: null,
      rootObserver: null,
      onLifecycle: null,
      onAfterChange: null,
      onDestroy: null,
    };
    if (!state.current || !state.total || !state.a11y) {
      deactivate(state);
      return null;
    }
    deactivate(state);
    return state;
  }

  function bindRoot(root) {
    var state = findState(root);
    try {
      if (!state) {
        state = createState(root);
        if (!state) return;
        states.push(state);
        observeRootReplacement(state);
      }
      tryBind(state);
    } catch (error) {
      if (state) deactivate(state);
    }
  }

  function boot(scope) {
    forEach(rootsInScope(scope), bindRoot);
  }

  function destroyState(state) {
    if (!state || state.destroyed) return;
    state.destroyed = true;
    clearReadyTimer(state);
    unbind(state);
    if (state.rootObserver) {
      state.rootObserver.disconnect();
      state.rootObserver = null;
    }
    deactivate(state);
    states = states.filter(function (candidate) { return candidate !== state; });
  }

  function destroyWithin(scope) {
    forEach(states.slice(), function (state) {
      if (scope === state.root ||
          (scope && typeof scope.contains === "function" && scope.contains(state.root))) {
        destroyState(state);
      }
    });
  }

  function onMediaChange() {
    forEach(states, function (state) {
      if (!isMobile()) {
        deactivate(state);
      } else if (state.bound && state.slider) {
        syncFromDom(state, null);
      } else {
        tryBind(state);
      }
    });
  }

  try {
    media = typeof window.matchMedia === "function" ? window.matchMedia(MOBILE_QUERY) : null;
    if (media && typeof media.addEventListener === "function") {
      media.addEventListener("change", onMediaChange);
    } else if (media && typeof media.addListener === "function") {
      media.addListener(onMediaChange);
    }
  } catch (error) {
    media = null;
  }

  var api = { boot: boot };
  if (commonJS) api.finalSlideTotal = finalSlideTotal;
  window[GLOBAL_NAME] = api;

  boot(document);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  }
  window.addEventListener("load", function () { boot(document); });
  window.addEventListener("pageshow", function () { boot(document); onMediaChange(); });
  document.addEventListener("shopify:section:load", function (event) {
    boot(event && event.target ? event.target : document);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    if (event && event.target) destroyWithin(event.target);
  });

  return api;
});
